import React from "react"
import {
  Button,
  Space,
  Section
} from 'AtomicComponents'
import {
  AccessoryItem,
  CardYoutubePlayerList,
} from 'AtomicContainers'

class AccessoryList extends React.Component {

  render() {

    const {
      title,
      description,
      gtm,
      linkText,
      storeLink,
      accessories,
    } = this.props

    return (
      <Section padding>
        <CardYoutubePlayerList
          heading={title}
          numberOfColumns={4}
          showCounting={false}
          description={description}
        >
          {accessories &&
            accessories.length > 0 &&
            accessories.map((item, index) =>
              <AccessoryItem
                key={`AccessoryItem-${index}`}
                name={item.name}
                priceText={item.priceText}
                partNumber={item.partNumber}
                description={item.description}
                isPack={item.isPack}
                imageUrl={item.imageUrl}
                gtm={{
                  category: gtm && gtm.category ? gtm.category : title,
                  action: gtm && gtm.action ? gtm.action : "Accessories"
                }}
              />
            )}
        </CardYoutubePlayerList>
        <Space />
        {storeLink &&
          <Button
            styleName="blackOutlined"
            href={storeLink}
            label={linkText || "browse all accessories"}
            gtm={gtm}
          />
        }
      </Section>
    )
  }
}

export default AccessoryList



// WEBPACK FOOTER //
// ./src/AtomicContainers/AccessoryList/AccessoryList.jsx